/**
 * 元数据配置的动作定义弹窗，弹窗弹出前的校验处理
 *
 * eg. 调接口校验单子的状态、缺货数量等等，不符合则不弹弹窗
 *
 * return true 校验通过 弹出弹窗
 * return false 不弹弹窗
 */
export default async ({ tab, vm }) => {
  console.log('btn::',tab);
  let flag = true
  if (tab.webname == "SG_B_DISTRIBUTION_ORDER_SPLIT_LIST") { // TOB配货单 - 指定订单拆单
    const params = new FormData();
    params.append('orderId', vm.idArray[0]);
    await vm.service.financeCenter
      .queryOrderInfoAndSkuList(params)
      .then((r) => {
        if (r.data.code != 0) {
          flag = false
        }
      })
      .catch((e) => {
        flag = false
      });
  } else if (tab.action.includes('CUSTOMIZED/DYNAMIC_API_HANDLER')) { // 通用动态接口调用处理
    // eg. 异常重试补偿任务-执行补偿
    flag = false
    vm.$R3loading.show(vm.loadingName);
    const fn = function (url) {
      let obj = {};
      url.replace(/([^?&]+)=([^?&]+)/g, function (s, v, k) {
        obj[v] = decodeURIComponent(k);
        return k + '=' + v;
      });
      return obj;
    }
    const apiFn = async function (obj) {
      let objid = '', row = {}
      if (vm.$route.fullPath.includes('/SYSTEM/TABLE/')) {
        objid = vm.idArray.join();
        const queryForm = vm.$refs.R3listform.ItemLists
        for (const [key, value] of Object.entries(vm.buttons.selectArr[0])) {
          for (const [key1, value1] of Object.entries(value)) {
            row[key] = value1
            if (queryForm.hasOwnProperty(key) && queryForm[queryForm].combobox.length) {
              row[key] = queryForm[queryForm].combobox.find( i => i.label == value1).value
            }
          }
        }
      } else if (vm.$route.fullPath.includes('/SYSTEM/TABLE_DETAIL/')) {
        objid = vm.$route.params.itemId;
        row = vm.$store.state[R3.getModuleName()].updateData[vm.tableName].default[vm.tableName];
      }
      function renderString(str, row) {
        const x = str.replace(/\$\{/g, (match) => { return '${row.' })
        return eval('`' + x + '`')
      }
      const url = renderString(obj.path, row)
      await vm.service.common.publicUrlParams(url, { objid }).then(res => {
        if (res.data.code == 0) {
          vm.$Message.success(res.data.message)
        }
      }).finally(e => {
        vm.$R3loading.hide(vm.loadingName);
      });
    }
    try {
      const query = fn(tab.action)
      apiFn(query)
    } catch (e) {
      vm.$R3loading.hide(vm.loadingName);
      $fcError(`error: ${e}`);
    }
  } else if (tab.action.includes('CUSTOMIZED/CUS_PRINT')) {
    // eg. 拣货单-打印
    vm.$R3loading.show(vm.loadingName);
    const fn = function (url) {
      let obj = {};
      url.replace(/([^?&]+)=([^?&]+)/g, function (s, v, k) {
        obj[v] = decodeURIComponent(k);
        return k + '=' + v;
      });
      return obj;
    }
    const printFn = async function (obj) {
      const query = Object.assign({}, obj)
      query.action = obj.webname
      if (vm.$route.fullPath.includes('/SYSTEM/TABLE/')) {
        query.ids = vm.idArray;
      } else if (vm.$route.fullPath.includes('/SYSTEM/TABLE_DETAIL/')) {
        query.id = vm.$route.params.itemId;
      }
      if (obj.printCode) {
        query.printCode = obj.printCode
      }
      await vm.service.common.publicUrlParams(obj.path, query).then(res => {
        if (res.data.code == 0) {
          vm.$Message.success(res.data.message)
          if (res.data.data) {
            if (res.data.data.url && res.data.data.url.includes('http')) {
              window.open(res.data.data.url)
            } else {
              window.open(res.data.data)
            }
          } else {
            $fcError(`error: ${JSON.stringify(res.data)}`);
          }
          flag = false
        } else {
          flag = false
        }
      }).finally(e => {
        flag = false
        vm.$R3loading.hide(vm.loadingName);
      });
    }
    const query = fn(tab.action)
    if (query.type == 'unselect') {
      // 不用选模板 -> 有固定模板
      printFn(query)
    } else {
      // 要选模板 -> 无固定模板
      query.action = tab.webname
      await vm.service.common.publicUrlParams('/api/cs/md/v2/print/queryList', query).then(res => {
        if (res.data.code == 0) {
          if (res.data.data.length == 1) {
            // 只有一个模板，则直接用该模板调打印
            printFn(Object.assign({}, tab, query, {
              printCode: res.data.data[0].ECODE
            }))
            flag = false
          } else {
            flag = Object.assign({}, tab, query, {
              tempData: res.data.data
            })
          }
        } else {
          flag = false
        }
      }).catch((e) => {
        flag = false
      }).finally(e => {
        vm.$R3loading.hide(vm.loadingName);
      });
    }
  }
  return flag
}
